// App.js
// rebuild
import React, { useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './css/base.css';
import ImageDisplay from './ImageDisplay';
import config from './config/config.json';

const API_AUTH_KEY = process.env.REACT_APP_API_KEY;

const App = () => {
  const transformWrapperRef = useRef(null);

  // Run ONCE on first client load
  useEffect(() => {
    const t = setTimeout(() => {
      if (transformWrapperRef.current) {
        transformWrapperRef.current.setTransform(0, 0, config.initialZoom); 
      }
    }, 150); // small delay so wrapper is mounted

    return () => clearTimeout(t);
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <ImageDisplay
              apiAuthKey={API_AUTH_KEY}
              transformWrapperRef={transformWrapperRef}
            />
          }
        />

        <Route
          path="/:userDate"
          element={
            <ImageDisplay
              apiAuthKey={API_AUTH_KEY}
              transformWrapperRef={transformWrapperRef}
            />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
